export enum ResponseCodeType {
  CREATE = <any>{actions: ['created', 'creating']},
  DELETE = <any>{actions: ['deleted', 'deleting']},
  UPDATE = <any>{actions: ['updated', 'updating']}
}
